var $83e624e07782526b$exports = {};
$83e624e07782526b$exports = {
    "clear": `Vymaza\u{165}`,
    "invalid": `(neplatn\xe9)`,
    "loading": `Na\u{10D}\xedtava sa...`,
    "noResults": `\u{17D}iadne v\xfdsledky`,
    "valid": `(platn\xe9)`
};


export {$83e624e07782526b$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
